export const CATEGORIES = [
  { id: 'ecommerce', name: 'فروشگاه اینترنتی', icon: 'ShoppingCart' },
  { id: 'restaurant', name: 'رستوران و کافه', icon: 'Coffee' },
  { id: 'medical', name: 'خدمات پزشکی و سلامت', icon: 'Heart' },
  { id: 'manufacturing', name: 'تولیدی و صنعتی', icon: 'Settings' },
  { id: 'startup', name: 'استارتاپ و فناوری', icon: 'Zap' },
  { id: 'agriculture', name: 'کشاورزی و دامپروری', icon: 'Leaf' },
  { id: 'services', name: 'خدمات عمومی', icon: 'Briefcase' },
];

export const TRL_LEVELS = [
  { id: 1, label: 'اصول پایه' },
  { id: 2, label: 'فرمولاسیون مفهوم' },
  { id: 3, label: 'اثبات آزمایشگاهی' },
  { id: 4, label: 'اعتبارسنجی آزمایشگاهی' },
  { id: 5, label: 'اعتبارسنجی محیط مرتبط' },
  { id: 6, label: 'نمایش در محیط مرتبط' },
  { id: 7, label: 'نمایش نمونه عملیاتی' },
  { id: 8, label: 'سیستم کامل و تایید شده' },
  { id: 9, label: 'سیستم عملیاتی اثبات شده' },
];

